import request from '@/utils/request';
// 分页查询项目
export function projectpage(data) {
  return request({
    url: 'config/project/page',
    method: 'post',
    data: data
  })
}
// 查询审核材料关键字
export function checkquery(id, str) {
  return request({
    url: 'config/check/query',
    method: 'post',
    data: {
      projectId: id,
      name: str
    }
  })
}
// 更新审核材料关键字
export function checkupdate(data) {
  return request({
    url: 'config/check/update',
    method: 'post',
    data: data
  })
}
// 导出审核材料关键字
export function checkexport(id) {
  return request({
    url: 'config/check/export',
    method: 'post',
    data: {
      projectId: id
    },
    responseType: 'blob'
  })
}
// 导入审核材料关键字
let checkimport = process.env.VUE_APP_BASE_API + 'config/check/import';
export {
  checkimport
}
// 查询物流材料关键字
export function receivequery(id, str) {
  return request({
    url: 'config/receive/query',
    method: 'post',
    data: {
      projectId: id,
      name: str
    }
  })
}
// 更新物流材料关键字
export function receiveupdate(data) {
  return request({
    url: 'config/receive/update',
    method: 'post',
    data: data
  })
}
// 导出物流材料关键字
export function receiveexport(id) {
  return request({
    url: 'config/receive/export',
    method: 'post',
    data: {
      projectId: id
    },
    responseType: 'blob'
  })
}
// 导入物流材料关键字
let receivimport = process.env.VUE_APP_BASE_API + 'config/receive/import';
export {
  receivimport
}
// 物流材料组里查询领药次数和条目
export function groupreceiveitems(id) {
  return request({
    url: 'file/group/receive/items',
    method: 'post',
    data: {
      id: id
    }
  })
}

// 特殊材料查询
export function configpage(data) {
  return request({
    url: 'sys/config/page',
    method: 'post',
    data
  })
}

// 特殊材料更新
export function configupdate(data) {
  return request({
    url: 'sys/config/update',
    method: 'post',
    data
  })
}

// 特殊材料新增
export function configadd(data) {
  return request({
    url: 'sys/config/add',
    method: 'post',
    data
  })
}

// 特殊材料删除
export function configdel(id) {
  return request({
    url: 'sys/config/del',
    method: 'post',
    data: {
      id: id
    }
  })
}
